let _router = null;
/**
 * Navigate programmatically from anywhere (sagas, utils, services)
 * @param path - path to navigate to
 * @param state - optional state object
 * @param replace - if true, acts like history.replace
 */
export function navigate(path, state, replace) {
    if (!_router)
        throw new Error("Router is not set. Call setRouter(router) during app init.");
    if (typeof path === "number") {
        _router.navigate(path);
    }
    _router.navigate(path.toString(), { replace, state });
}
export function setRouter(router) {
    _router = router;
}
